import { render, staticRenderFns } from "./RsaPazienteAreeComponent.vue?vue&type=template&id=2d4801e8&scoped=true"
import script from "./RsaPazienteAreeComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazienteAreeComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaPazienteAreeComponent.vue?vue&type=style&index=0&id=2d4801e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4801e8",
  null
  
)

export default component.exports